import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiFacebook, FiInstagram } from "react-icons/fi";
import "./footer.css";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <Container>
        {/* ================= ÜST KOLONLAR ================= */}
        <Row className="gy-5 gx-lg-5 justify-content-between">
          {/* Kolon 1: Logo, Başlık, Slogan ve Sosyal Medya Butonları */}
          <Col xs={12} md={6} lg={4}>
            <div className="footer-brand-title">Mevzu Yaşam Akademi</div>
            <p className="footer-brand-desc">
              Hedeflerinizi netleştirmenize, potansiyelinizi keşfetmenize ve
              başarıya daha emin adımlarla ilerlemenize destek oluyoruz.
            </p>

            {/* Sosyal Medya İkon Alanı */}
            <div className="mt-3">
              <span className="text-secondary small fw-semibold d-block mb-2">
                Bizi Takip Edin:
              </span>
              <div className="footer-social-wrap">
                <a
                  href="https://www.instagram.com/mevzuyasam/?igshid=MzRlODBiNWFlZA%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  aria-label="Instagram"
                >
                  <FiInstagram size={17} />
                </a>
                <a
                  href="https://www.facebook.com/Gamze.Nur.Akdemr?mibextid=9R9pXO"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-btn"
                  aria-label="Facebook"
                >
                  <FiFacebook size={17} />
                </a>
              </div>
            </div>
          </Col>

          {/* Kolon 2: Navigasyon / Menü */}
          <Col xs={6} md={3} lg={2}>
            <div className="footer-col-title">Menü</div>
            <ul className="footer-nav-list">
              <li>
                <Link to="/" className="footer-link">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkımızda" className="footer-link">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/blog" className="footer-link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/iletişim" className="footer-link">
                  İletişim
                </Link>
              </li>
            </ul>
          </Col>

          {/* Kolon 3: Hizmetlerimiz */}
          <Col xs={6} md={3} lg={2}>
            <div className="footer-col-title">Hizmetlerimiz</div>
            <ul className="footer-nav-list">
              <li>
                <Link to="/programlar" className="footer-link">
                  Öğrenci Koçluğu
                </Link>
              </li>
              <li>
                <Link to="/programlar" className="footer-link">
                  Hızlı Okuma
                </Link>
              </li>
              <li>
                <Link to="/programlar" className="footer-link">
                  Yaşam Koçluğu
                </Link>
              </li>
              <li>
                <Link to="/programlar" className="footer-link">
                  Eğitim Danışmanlığı
                </Link>
              </li>
              <li>
                <Link to="/programlar" className="footer-link">
                  Veli Rehberliği
                </Link>
              </li>
            </ul>
          </Col>

          {/* Kolon 4: İletişim Bilgileri */}
          <Col xs={12} md={6} lg={3}>
            <div className="footer-col-title">İletişim</div>

            <div className="footer-contact-group">
              <span className="footer-contact-label d-flex align-items-center gap-2">
                Adres:
              </span>
              <p className="footer-contact-value">
                Kentkoop Mah. 1865. Sokak Petunya Apt. A-1 No:7 Yenimahalle /
                Ankara
              </p>
            </div>

            <div className="footer-contact-group">
              <span className="footer-contact-label d-flex align-items-center gap-2">
                Telefon:
              </span>
              <a
                href="tel:05074660618"
                className="footer-contact-value text-decoration-none footer-link"
              >
                +90 507 466 06 18
              </a>
            </div>
          </Col>
        </Row>

        {/* ================= AYIRICI ÇİZGİ ================= */}
        <div className="footer-divider" />

        {/* ================= DİNAMİK YIL VE GİZLİLİK ================= */}
        <div className="footer-bottom-bar flex-column flex-md-row gap-3 text-center text-md-start">
          <Link to="/gizlilik-politikasi" className="footer-privacy-link">
            Gizlilik Politikası (Privacy Policy)
          </Link>

          <div>© {currentYear} Tüm hakları saklıdır Mevzu Yaşam Akademi</div>
        </div>
      </Container>
    </footer>
  );
}
